// extracted by mini-css-extract-plugin
export default {"onlyDark":"WorkExperienceItems_onlyDark__TjToT","onlyLight":"WorkExperienceItems_onlyLight__LMT+p","work-experience-items":"WorkExperienceItems_work-experience-items__vUJk0"};